/**
 * MessageAuthorLabel — who wrote a message: a person, a persona, an employee or an external agent, each a member of
 * the conversation (conversation-members spec). Shown at the top of the message, as the sender's name heads an
 * incoming bubble on the demo's /chats page. The author comes from the message itself (`author`), which a model
 * never chooses.
 */
import { memberKindLabel } from '@confluent/shared/lib/conversation-addressing';
import type { ConversationMemberRef } from '@confluent/shared/lib/conversation-addressing';
import { Avatar } from '../ui/Avatar.js';
import { Badge } from '../ui/Badge.js';

export function MessageAuthorLabel({ author }: { author: ConversationMemberRef }) {
  const kind = memberKindLabel(author.memberType);
  return (
    <div className="flex items-center gap-2" aria-label={`From ${author.name}, ${kind.toLowerCase()}`}>
      <Avatar kind={author.memberType === 'user' ? 'human' : 'ai'} label={author.name} size={24} />
      <span className="text-sm font-medium text-heading">{author.name}</span>
      <Badge variant={author.memberType === 'user' ? 'neutral' : 'accent'}>{kind}</Badge>
      {author.role === 'lead' && <Badge variant="info">Lead</Badge>}
    </div>
  );
}
